// Cached list of the signed-in user's contests (60s TTL, shared app-wide).
import { useEffect, useState } from "react";
import useAuth from "./useAuth";
import { listMyContests } from "@/lib/authApi";

let cache = { at: 0, data: null, promise: null };

export default function useMyContests() {
  const { isSignedIn } = useAuth();
  const [contests, setContests] = useState(cache.data || []);

  useEffect(() => {
    if (!isSignedIn) {
      setContests([]);
      return;
    }
    if (cache.data && Date.now() - cache.at < 60000) {
      setContests(cache.data);
      return;
    }
    if (!cache.promise) {
      cache.promise = listMyContests()
        .then((d) => {
          cache = { at: Date.now(), data: d || [], promise: null };
          return cache.data;
        })
        .catch(() => {
          cache.promise = null;
          return [];
        });
    }
    let on = true;
    cache.promise.then((d) => on && setContests(d || []));
    return () => {
      on = false;
    };
  }, [isSignedIn]);

  return contests;
}
